export default __webpack_public_path__ + "static/media/wildAnimals.a33c053b.png";